import "@/App.css";
import { useStore } from "@/store/useStore";
import Landing from "@/components/Landing";
import Showroom from "@/components/Showroom";
import ErrorBoundary from "@/components/ErrorBoundary";

function App() {
  const entered = useStore((s) => s.entered);
  return (
    <div className="app-root grain" data-testid="app-root">
      {entered ? (
        <ErrorBoundary>
          <Showroom />
        </ErrorBoundary>
      ) : (
        <Landing />
      )}
    </div>
  );
}

export default App;
